import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'image-card',
    template: `
        <img
            class="w-full h-50 md:w-80 md:h-54 object-cover flex-shrink-0 rounded-2xl shadow-sm bg-gray-100"
            [src]="image ?? '/assets/images/placeholder-image2.png'"
            alt=""
          />
    `
})

export class ImageCardComponent implements OnInit {
    @Input() image:string= ''
    //archivoFavorito?.blobURL
    constructor() { }

    ngOnInit() { }
}